(function (global) {
  'use strict';
  const VERSION = '1.3.0';
  const POOL_VERSION = '1.3.0';
  const WINDOW_MS = 14400000;
  const SOURCES = ['15-40-off-limited-deals','61-70-off','bath-goods','electronics-1','home-kitchen','personal-care','sports-outdoors','save-more'];
  const CONFIG = {
    save: {handle:'61-70-off',color:'yellow',title:'Save More · وفر أكثر'},
    category: {handle:'15-40-off-limited-deals',color:'blue',title:'15%–40% Off · خصم 15%–40%'},
    baby: {handle:'bath-goods',color:'green',title:'60%–65% Off · خصم 60%–65%'},
    tech: {handle:'electronics-1',color:'pink',title:'Up to 50% Off · خصم يصل إلى 50%'}
  };
  function hash(s) { let h=2166136261; for (let i=0;i<s.length;i++) h=Math.imul(h^s.charCodeAt(i),16777619); return h>>>0; }
  function unique(records) { const seen=new Set(); return records.filter(p=>{if(seen.has(p.id))return false;seen.add(p.id);return true;}); }
  function ordered(records,batch,market) {
    const sorted=unique(records).sort((a,b)=>hash(market+'|'+a.id)-hash(market+'|'+b.id)||a.id.localeCompare(b.id));
    const offset=sorted.length ? batch%sorted.length : 0;
    return sorted.slice(offset).concat(sorted.slice(0,offset));
  }
  function pools(records) {
    return {
      save:unique(records.filter(p=>['15-40-off-limited-deals','61-70-off','save-more'].includes(p.source)&&p.band)),
      category:unique(records.filter(p=>p.band)),
      baby:unique(records.filter(p=>p.band6065)),
      tech:unique(records.filter(p=>p.under50))
    };
  }
  function plan(records,{batch,market='GLOBAL',limit=14}) {
    if(!Number.isInteger(batch)||batch<0)throw Error('Explicit valid batch required');
    const pool=pools(records),used=new Set(),areas={};
    for(const key of ['baby','save','category','tech']) {
      const counts={}; areas[key]=[];
      const candidates=ordered(pool[key],batch,market);
      for(const p of candidates) {
        if(used.has(p.id)||(key!=='baby'&&(counts[p.category]||0)>=3))continue;
        areas[key].push(p);used.add(p.id);counts[p.category]=(counts[p.category]||0)+1;
        if(areas[key].length===limit)break;
      }
      // Diversity is a preference. Eligibility and unique real products are mandatory.
      if(areas[key].length<limit)for(const p of candidates) {
        if(used.has(p.id))continue;
        areas[key].push(p);used.add(p.id);
        if(areas[key].length===limit)break;
      }
      areas[key].sort((a,b)=>hash(market+'|'+a.id)-hash(market+'|'+b.id)||a.id.localeCompare(b.id));
      if(batch%2)areas[key].reverse();
    }
    return {batch,areas,pools:pool};
  }
  const engine=Object.freeze({VERSION,WINDOW_MS,SOURCES,CONFIG,hash,ordered,pools,plan});
  if(typeof module==='object'&&module.exports){module.exports=engine;return;}
  const window=global,document=window.document;
  if(!document)return;
  let batch=Math.floor(Date.now()/WINDOW_MS);
  const market=window.Shopify?.country||'GLOBAL';
  const route=window.Shopify?.routes?.root||'/';
  const mobile=window.matchMedia('(max-width:767px)');
  const targets=[];
  const landing=document.querySelector('[data-nimall-deals-landing]');
  if(landing) {
    const area=landing.dataset.dealsArea;
    targets.push({root:landing,key:area,landing:true,mode:'pc',container:landing.querySelector('[data-deals-grid="pc"]')});
    targets.push({root:landing,key:area,landing:true,mode:'mobile',container:landing.querySelector('[data-deals-grid="mobile"]')});
  } else for(const [key,config] of Object.entries(CONFIG)) {
    const pc=document.querySelector('[data-product-block][data-collection="'+config.handle+'"]');
    const wap=document.querySelector('.y01-home .y01-shelf--'+config.color);
    if(pc)targets.push({root:pc,key,mode:'pc',container:pc.querySelector('.products-grid')});
    if(wap)targets.push({root:wap,key,mode:'mobile',container:wap.querySelector('.y01-product-rail')});
  }
  if(!targets.length)return;
  let poolPromise,result;
  const states=new WeakMap();
  function visible(target){return target.container&&target.container.getClientRects().length>0;}
  async function fetchSource(handle) {
    const controller=new AbortController(),timer=window.setTimeout(()=>controller.abort(),25000);
    try {
      const response=await window.fetch(route+'collections/'+handle+'?view=nimall-save-more&batch='+batch+'&deals_version='+VERSION,{credentials:'same-origin',cache:'no-store',signal:controller.signal});
      if(!response.ok)throw Error('POOL_HTTP_'+response.status);
      const html=await response.text(),doc=new DOMParser().parseFromString(html,'text/html'),wrapper=doc.querySelector('[data-save-more-pool]');
      if(!wrapper||wrapper.dataset.version!==POOL_VERSION||wrapper.dataset.source!==handle)throw Error('INVALID_POOL_'+handle);
      return {date:Date.parse(response.headers.get('date')),records:Array.from(doc.querySelectorAll('template[data-save-more-id]'),t=>({id:t.dataset.saveMoreId,handle:t.dataset.saveMoreHandle,category:t.dataset.saveMoreCategory,band:t.dataset.saveMoreBand==='true',band6065:t.dataset.discount6065==='true',under50:t.dataset.discountUnder50==='true',source:handle,template:t}))};
    } finally {window.clearTimeout(timer);}
  }
  function loadPool() {
    if(poolPromise)return poolPromise;
    poolPromise=(async()=>{
      const responses=[];
      for(let i=0;i<SOURCES.length;i+=3)responses.push(...await Promise.all(SOURCES.slice(i,i+3).map(handle=>fetchSource(handle).catch(error=>{if(handle==='save-more'){console.warn('Nimall automatic pool unavailable; using existing pools',error.message);return {date:NaN,records:[]};}throw error;}))));
      const serverDate=responses.find(r=>Number.isFinite(r.date))?.date;
      if(serverDate)batch=Math.floor(serverDate/WINDOW_MS);
      const records=responses.flatMap(r=>r.records);
      result=plan(records,{batch,market});
      return result;
    })().catch(error=>{poolPromise=undefined;throw error;});
    return poolPromise;
  }
  function enhance(container) {
    container.querySelectorAll('img[data-src],img[data-srcset]').forEach(image=>{
      if(image.dataset.srcset)image.srcset=image.dataset.srcset;
      if(image.dataset.src)image.src=image.dataset.src;
      if(!image.getAttribute('src')&&image.dataset.srcset)image.src=image.dataset.srcset.split(',')[0].trim().split(/\s+/)[0];
      image.classList.remove('lazyload');image.classList.add('lazyloaded');
    });
    const shared=window.sharedFunctions||{};
    if(shared.setLocalStorageProductForWishlist&&window.wishlist?.show)shared.setLocalStorageProductForWishlist();
  }
  function titles(t) {
    const title=t.landing?t.root.querySelector('h1'):t.root.querySelector('.halo-block-header .title .text, .halo-block-header .title, .y01-section-heading h2');
    if(title) {
      const [en,ar]=CONFIG[t.key].title.split(' · ');
      const english=document.createElement('bdi');english.dir='ltr';english.lang='en';english.textContent=en;
      const arabic=document.createElement('bdi');arabic.dir='rtl';arabic.lang='ar';
      let start=0;
      for(const match of ar.matchAll(/\d+%(?:–\d+%)?/g)) {
        arabic.appendChild(document.createTextNode(ar.slice(start,match.index)));
        const number=document.createElement('bdi');number.dir='ltr';number.textContent=match[0];arabic.appendChild(number);start=match.index+match[0].length;
      }
      arabic.appendChild(document.createTextNode(ar.slice(start)));
      title.replaceChildren(english,document.createTextNode(' · '),arabic);
    }
    if(t.landing)return;
    const link=t.root.querySelector('.halo-block-header .view_all, .y01-section-heading a');
    if(link)link.href=route+'collections/'+CONFIG[t.key].handle+'?view=nimall-deals';
  }
  function paint(t,r) {
    const selection=t.landing?ordered(r.pools[t.key],batch,market):r.areas[t.key];
    if(!selection.length)throw Error('EMPTY_QUALIFIED_POOL_'+t.key);
    const fragment=document.createDocumentFragment();
    for(const p of selection){const card=p.template.content.querySelector('[data-save-more-mode="'+t.mode+'"] > *');if(card)fragment.appendChild(card.cloneNode(true));}
    t.container.replaceChildren(fragment);t.container.dataset.ncbManaged='deals-v11';
    t.root.dataset.dealsVersion=VERSION;t.root.dataset.dealsBatch=String(batch);t.root.dataset.dealsState='loaded';
    if(t.key==='save'){t.root.dataset.saveMoreVersion=VERSION;t.root.dataset.saveMoreBatch=String(batch);t.root.dataset.saveMoreState='loaded';}
    t.container.dataset.dealsIds=selection.map(p=>p.id).join(',');
    states.set(t,'loaded');titles(t);enhance(t.container);
  }
  async function activate(t) {
    if(!visible(t)||['loading','loaded'].includes(states.get(t)))return;
    states.set(t,'loading');t.root.dataset.dealsState='loading';
    const pending=document.createElement('p');pending.setAttribute('role','status');pending.textContent='Loading deals · جارٍ تحميل العروض';t.container.replaceChildren(pending);
    try {paint(t,await loadPool());}
    catch(error){
      states.set(t,'error');t.root.dataset.dealsState='error';
      if(t.key==='save')t.root.dataset.saveMoreState='error';
      t.container.replaceChildren();
      if(!t.container.querySelector('[data-deals-retry]')){
        const retry=document.createElement('button');retry.type='button';retry.dataset.dealsRetry='';retry.className='button button--secondary';retry.textContent='Reload deals · إعادة تحميل العروض';
        retry.addEventListener('click',()=>{retry.remove();activate(t);});t.container.appendChild(retry);
      }
      console.warn('Nimall deals unavailable',error.message);
    }
  }
  for(const t of targets) {
    if(!t.container)continue;
    t.container.dataset.ncbManaged='deals-v11';titles(t);
    if(t.mode==='pc'&&!t.landing)t.root.classList.add('ajax-loaded');
    if('IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting)activate(t);}),{rootMargin:'1000px 0px'});observer.observe(t.container);}else activate(t);
  }
  mobile.addEventListener('change',()=>targets.forEach(t=>{if(visible(t)){if(result)paint(t,result);else activate(t);}}));
  const state=()=>({version:VERSION,windowMs:WINDOW_MS,batch,market,areas:targets.filter(visible).map(t=>({key:t.key,mode:t.mode,state:states.get(t),ids:(t.container.dataset.dealsIds||'').split(',').filter(Boolean)}))});
  window.NimallDeals=Object.freeze({version:VERSION,windowMs:WINDOW_MS,getState:state});
  window.NimallSaveMore=Object.freeze({version:VERSION,getState:()=>state().areas.filter(t=>t.key==='save')});
})(typeof window==='undefined'?globalThis:window);
